import { useEffect, useState, useRef, useContext } from "react";
import { DataTable, DataTableExpandedRows } from "primereact/datatable";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "primereact/resources/primereact.min.css";
import { FilterMatchMode } from "primereact/api";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { InputIcon } from "primereact/inputicon";
import { IconField } from "primereact/iconfield";
import { Tag } from "primereact/tag";
import { Checkbox } from "primereact/checkbox";
import { Calendar } from "primereact/calendar";
import { Dialog } from "primereact/dialog";
import "../shared/maintenanceHeader.css";
import "./index.css";
import Modal from "../../ui/modal/modal";
import Avatar from "/src/assets/images/male-avatar.png";
import * as api from "../../../utils/Api.ts";
import { InitDataContext } from "../../../context/InitDataContext.tsx";
import PdfCreator from "../../../components/generate-pdf-from-data/generatePdfFromData";
import DownloadFiles from "../../widgets/DownloadFiles.tsx";
import ModalConfirm from "../../ui/modal/ModalConfirm.tsx";
import { InitDataNewOrderContext } from "../../../context/InitDataNewOrder.tsx";
import DropdownFilter from "../../dropdown/DropdownFilter.tsx";
import { FloatLabel } from "primereact/floatlabel";
import { Toast } from "primereact/toast";
import { showMsg } from "../../../utils/Constants.tsx";
import ModalSignature from "../../ui/modal/ModalSignature.tsx";
import { useNavigate } from "react-router-dom";
import { InputNumber } from "primereact/inputnumber";

interface OrdenCompra {
  id_sub_tipo_documento: any;
  id_usuario_solicitante: any;
  id_mes_gasto: any;
  id_estado_operacional: any;
  id_tipo_moneda: any;
  id_proveedor: any;
  url_orden_compra_pdf: string;
  url_archivos_asociados_pdf: string;
  observaciones: string;
  tipo_cambio_dia: any;
  id_estado_orden: number;
  id_tipo_doc_tributario: number;
  condicion_pago: number;
  es_combustible?: boolean;
  fecha_orden?: Date | null;
  impuesto_especifico?: number | null;
  dt_cre: Date;
  dt_mod: Date;
  detalles: any[];
}

export default function TableDataCreateOrder() {
  //**************************** VARIABLES Y ESTADOS *******************************/
  const [data, setData] = useState<any>([]);
  const navigate = useNavigate();
  const { initData } = useContext(InitDataContext);
  const { tiposDocumentosTributarios, condicionesPago } = useContext(
    InitDataNewOrderContext,
  );
  const [expandedRows, setExpandedRows] = useState<
    DataTableExpandedRows[] | undefined
  >(undefined);
  const [filters, setFilters] = useState<{
    [key: string]: { value: string | null; matchMode: FilterMatchMode };
  }>({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    subdoc_nombre: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    soc_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    nombres: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    cc_nombre: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    soc_dt_cre: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    socest_nombre: { value: null, matchMode: FilterMatchMode.EQUALS },
  });

  const [goHome, setGoHome] = useState(false);
  useEffect(() => {
    if (goHome) {
      navigate("/", { replace: true });
    }
  }, [goHome]);

  const [isLoading, setIsLoading] = useState(true);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const toast = useRef<Toast>(null);
  const [selectedRow, setSelectedRow] = useState<any[] | null>(null);
  const [rowClick, setRowClick] = useState(true);
  const [dialogVisible, setDialogVisible] = useState(false);
  const solicitudesCompra = useRef();
  const solicitudesCompraDetalles = useRef();
  const solicitudesApprovalStates = useRef<any[]>([]);
  const solicitudesSignApprovalHistory = useRef<any[]>([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const selectedSolicitudeHeaders = useRef<any[]>([]);
  const selectedSolicitudeDetails = useRef<any[]>([]);
  const [showModalConfirm, setShowModalConfirm] = useState(false);

  // States for order details
  const [selectedTipoDocTributarioId, setSelectedTipoDocTributarioId] =
    useState<number>(0);
  const [selectedTipoDocTributario, setSelectedTipoDocTributario] =
    useState<string>("Seleccione...");
  const [selectedCondicionPagoId, setSelectedCondicionPagoId] =
    useState<number>(0);
  const [selectedCondicionPago, setSelectedCondicionPago] =
    useState<string>("Seleccione...");
  const [selectedTasaCambio, setSelectedTasaCambio] = useState<number | null>(
    1,
  );

  // States for New Order Details Modal (Combustibles)
  const [showModalDetails, setShowModalDetails] = useState<boolean>(false);
  const [esCombustible, setEsCombustible] = useState<boolean>(false);
  const [fechaOrden, setFechaOrden] = useState<Date | null>(null);
  const [impuestoEspecifico, setImpuestoEspecifico] = useState<number | null>(
    null,
  );

  const [jsonDataOrdenCompra, setJsonDataOrdenCompra] = useState<
    OrdenCompra | undefined
  >();
  const [needFetchingSoc, setNeedFetchingSoc] = useState(false);
  const [showModalFirma, setShowModalFirma] = useState(false);

  const getTiposEstado = (status: any) => {
    switch (status) {
      case "Anulada":
        return "danger";

      case "Aprobada":
        return "success";

      case "Pendiente":
        return "info";

      case "Rechazada":
        return "warning";

      case "default":
        return null;
    }
  };

  useEffect(() => {
    if (data.length || needFetchingSoc) return;
    setNeedFetchingSoc(true);
  }, [data]);

  useEffect(() => {
    const fetchSolicitudesComfirmadas = async () => {
      const responseGetSolicitudesCompraConfirmadas =
        await api.GET_SOLICITUDES_COMPRA_BY_ESTADO.getSolicitudesCompraByEstado(
          7,
          8,
        );
      if (responseGetSolicitudesCompraConfirmadas !== null) {
        solicitudesCompra.current = responseGetSolicitudesCompraConfirmadas;

        const responseGetSolicitudesOrdenesCompraConfDetails =
          await api.GET_SOLICITUDES_COMPRA_BY_ESTADO_DETALLES.getSolicitudesCompraByEstadoDetalle(
            8,
          );
        if (responseGetSolicitudesOrdenesCompraConfDetails !== null) {
          solicitudesCompraDetalles.current =
            responseGetSolicitudesOrdenesCompraConfDetails;
          //MERGE ARRAYS
          let parent: Array<any> =
            solicitudesCompra.current as unknown as Array<any>;
          let detalle: Array<any> =
            solicitudesCompraDetalles.current as unknown as Array<any>;

          function callback(obj: any) {
            const childs = detalle?.filter(
              (childObj: any) =>
                childObj["socdet_id_solicitud_orden_compra"] === obj["soc_id"],
            );

            let childArray = [];
            if (obj.detalle !== undefined) {
              childArray = obj.detalle;
            }
            childArray = [...childArray, ...childs];
            return { ...obj, detalle: childArray };
          }
          const result = parent ? parent.map(callback) : [];
          setData(result);
          setTotalRecords(data.length);
          setNeedFetchingSoc(false);
        } else {
          showMsg(
            toast,
            "danger",
            "Error",
            "Error capturando datos de detalle de ordenes",
          );
        }
      } else {
        showMsg(toast, "danger", "Error", "Error capturando datos de ordenes");
      }
    };

    fetchSolicitudesComfirmadas();
  }, []);

  const fetchDatosAprobacionesConfirmaciones = async (idSolicitude: number) => {
    const responseGetSolicitudesStatesApproval =
      await api.GET_SOLICITUDE_APPROVALS_STATES.getSolicitudesApprovalStates(
        idSolicitude,
      );
    if (responseGetSolicitudesStatesApproval !== null) {
      solicitudesApprovalStates.current = responseGetSolicitudesStatesApproval;
    } else {
      showMsg(
        toast,
        "danger",
        "Error",
        "Ha ocurrido un error capturando los datos de estados de la solicitud",
      );
    }
  };

  const fetchDatosFirmaAprobacionesConfirmaciones = async (
    idSolicitude: number,
  ) => {
    const responseGetSignSolicitudesStatesApproval =
      await api.GET_SIGN_SOLICITUDE_HISTORY.getSignSolicitudeHistory(
        idSolicitude,
      );
    if (responseGetSignSolicitudesStatesApproval !== null) {
      solicitudesSignApprovalHistory.current =
        responseGetSignSolicitudesStatesApproval;
    } else {
      showMsg(
        toast,
        "danger",
        "Error",
        "Ha ocurrido un error capturando los datos de firma historia de la solicitud",
      );
    }
  };

  const fetchTipoCambioDiaParaTipoMoneda = (idTipoMoneda: number) => {
    let responseGetTipoCambio = null;

    try {
      responseGetTipoCambio = { serie: [{ valor: 1 }] };
      return responseGetTipoCambio.serie[0].valor;
    } catch (error) {
      console.log("Error al obtener tipo de cambio: ", error);
    }
  };

  /*************************** EVENTOS FUNCIONES *************************/
  const handleChangeEstadoSolicitud = (numeroSolicitud: number) => {
    if (numeroSolicitud > 1) {
      return (
        <div style={{ width: "80%", height: "40%" }}>
          HOLAAAAAAAAAAAA
          <Modal />
        </div>
      );
    }
  };

  const onGlobalFilterChange = (e: any) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const renderHeader = () => {
    return (
      <div className="oc-search">
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            placeholder="Búsqueda general..."
          />
        </IconField>
      </div>
    );
  };

  const solicitanteBodyTemplate = (rowData: any) => {
    return (
      <div className="oc-user">
        <img alt="solicitante" src={Avatar} />
        <span>{rowData.nombres}</span>
      </div>
    );
  };

  useEffect(() => {
    setIsLoading(false);
  });

  const solicitanteFilterTemplate = (options: any) => {
    return (
      <div className="flex align-items-center gap-2">
        <img alt="Búsqueda solicitante" src={Avatar} width="32" />
        <span></span>
      </div>
    );
  };

  /****************************** DIALOG MODAL ***************************/

  const dialogFooterTemplate = () => {
    return (
      <Button
        label="Ok"
        icon="pi pi-check"
        onClick={() => setDialogVisible(false)}
      />
    );
  };

  const archivoBodyTemplate = (data: any) => {
    const parts = data.soc_dt_cre.split("-");
    const mes = parts[1];
    const ano = parts[2];

    return (
      <div className="oc-download">
        <DownloadFiles
          path={`solicitudes/${ano}/${mes}/${data.soc_id}`}
          numDoc={data.soc_id}
          className="oc-btn oc-btn--outline"
          pdf={false}
        />
      </div>
    );
  };

  //************************ ESTADO FUNCIONES FILTRO *********************/
  const estadoBodyTemplateSelected = (option: any) => {
    return (
      <Tag
        className="tagTable"
        value={option.socest_nombre}
        severity={getTiposEstado(option.socest_nombre)}
      >
        {option}
      </Tag>
    );
  };

  const estadoBodyTemplate = (option: any) => {
    return (
      <Tag
        className="tagTable"
        value={option.socest_nombre}
        severity={getTiposEstado(option.socest_nombre)}
        onClick={() => handleChangeEstadoSolicitud(option.socest_id)}
      />
    );
  };

  const estadoRowFilterTemplate = (
    options: ColumnFilterElementTemplateOptions,
  ) => {
    const uniqueEstados = Array.from(
      new Set(data.map((item: { socest_nombre: any }) => item.socest_nombre)),
    );
    return (
      <Dropdown
        value={options.value}
        options={uniqueEstados}
        onChange={(e) => options.filterApplyCallback(e.value)}
        itemTemplate={estadoBodyTemplateSelected}
        placeholder="Seleccione..."
        className="p-column-filter"
        showClear
        style={{ minWidth: "12rem" }}
      />
    );
  };

  /******************************* ROW EXPANSION PARA DETALLES DE SOLICITUD ************************/

  const onRowExpand = (event: any) => {};

  const onRowCollapse = (event: any) => {};

  const expandAll = () => {
    let _expandedRows: any = {};

    data.forEach((p: any) => {
      if (p.detalle.length > 0) {
        _expandedRows[`${p.soc_id}`] = true;
      }
    });

    setExpandedRows(_expandedRows);
  };

  const collapseAll = () => {
    setExpandedRows(undefined);
  };

  const allowExpansion = (rowData: any) => {
    return rowData[0].detalle.length > 0;
  };

  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(data);

      const worksheetDetail = xlsx.utils.json_to_sheet(
        data.flatMap((item: any) => item.detalle || []),
      );

      const workbook = {
        Sheets: { data: worksheet, detalle: worksheetDetail },
        SheetNames: ["data", "detalle"],
        Props: {},
      };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "buffer",
      });

      saveAsExcelFile(excelBuffer, "products");
    });
  };

  const saveAsExcelFile = (buffer: BlobPart, fileName: string) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        module.default.saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION,
        );
      }
    });
  };

  const isDetailSelected = (list: any[] | null, detail: any) =>
    (list ?? []).some((obj: any) => obj.socdet_id === detail.socdet_id);

  const getSolicitudeOfDetail = (detail: any) =>
    data.find(
      (obj: any) => obj.soc_id == detail.socdet_id_solicitud_orden_compra,
    );

  // Applies a new detail selection: items already selected are kept, and each
  // newly added item must match the current selection (proveedor, moneda,
  // tipo de documento y mes de gasto); the ones that don't are discarded.
  const applyDetailSelection = (value: any[]) => {
    const kept = value.filter((obj: any) => isDetailSelected(selectedRow, obj));
    const added = value.filter(
      (obj: any) => !isDetailSelected(selectedRow, obj),
    );

    const validated = [...kept];
    let warning: string | null = null;

    added.forEach((detail: any) => {
      const reference = validated[0];
      if (!reference) {
        validated.push(detail);
        return;
      }
      const referenceSolicitude = getSolicitudeOfDetail(reference);
      const solicitude = getSolicitudeOfDetail(detail);

      let error: string | null = null;
      if (detail.prov_id !== reference.prov_id) {
        error = "No pueden ser distintos los proveedores";
      } else if (solicitude?.tipmon_id !== referenceSolicitude?.tipmon_id) {
        error = "No pueden ser distintos los tipos de moneda";
      } else if (solicitude?.subdoc_id !== referenceSolicitude?.subdoc_id) {
        error = "No pueden ser distintos los tipos de documento";
      } else if (solicitude?.meses_id !== referenceSolicitude?.meses_id) {
        error = "No pueden ser distintos los meses de gasto asociados";
      }

      if (error) {
        warning = warning ?? error;
      } else {
        validated.push(detail);
      }
    });

    if (warning) {
      showMsg(toast, "warn", "Advertencia", warning);
    }

    selectedSolicitudeHeaders.current = data.filter((obj: any) =>
      validated.some(
        (detail: any) => detail.socdet_id_solicitud_orden_compra == obj.soc_id,
      ),
    );
    selectedSolicitudeDetails.current = validated;
    setSelectedRow(validated);
  };

  const onSelectionDetailChange = (event: any) => {
    applyDetailSelection(event.value ?? []);
  };

  // Header checkbox of a solicitud: selects / unselects only its own items,
  // keeping the items selected in other solicitudes.
  const onSelectedAllDetailsChange = (event: any, dataSolicitude: any) => {
    const others = (selectedRow ?? []).filter(
      (obj: any) => !isDetailSelected(dataSolicitude.detalle, obj),
    );
    applyDetailSelection(
      event.checked ? [...others, ...dataSolicitude.detalle] : others,
    );
  };

  const handleUpdateTipoDocTribFromChild = (option: any) => {
    setSelectedTipoDocTributario(option.nombre);
    setSelectedTipoDocTributarioId(option.id);
  };

  const handleUpdateCondicionPagoFromChild = (option: any) => {
    setSelectedCondicionPago(option.nombre);
    setSelectedCondicionPagoId(option.id);
  };

  // Step 1: Triggered when "GENERAR" is clicked
  const saveOrdenCompra = () => {
    if (
      selectedSolicitudeHeaders.current.length > 0 &&
      selectedSolicitudeDetails.current.length > 0
    ) {
      // Show details modal to fill in tax document, rate, payment condition, and fuel options
      setShowModalDetails(true);
    } else {
      showMsg(
        toast,
        "warn",
        "Advertencia",
        "Debe seleccionar detalles de solicitudes confirmadas para crear la orden de compra.",
      );
    }
  };

  // Step 2: Triggered inside the Details Modal when clicking "Siguiente"
  const handleConfirmDetails = () => {
    const mainTipMonId = selectedSolicitudeHeaders.current[0]?.tipmon_id;

    if (selectedTipoDocTributarioId === 0) {
      showMsg(
        toast,
        "warn",
        "Advertencia",
        "Debe seleccionar un tipo de documento tributario para la orden de compra.",
      );
      return;
    }

    if (
      (selectedTasaCambio ?? 0) === 1 &&
      mainTipMonId !== 1 &&
      mainTipMonId !== 39
    ) {
      showMsg(
        toast,
        "warn",
        "Advertencia",
        "Debe seleccionar una tasa de cambio para la orden de compra a crear.",
      );
      return;
    }

    /* if (
      ((selectedTasaCambio ?? 0) > 1 && mainTipMonId === 1) ||
      mainTipMonId === 39
    ) {
      showMsg(
        toast,
        "warn",
        "Advertencia",
        "El tipo de moneda seleccionado corresponde a moneda nacional, la tasa debe permanecer en 1 para crear la orden de compra.",
      );
      return;
    }*/

    if (selectedCondicionPagoId === 0) {
      showMsg(
        toast,
        "warn",
        "Advertencia",
        "Debe seleccionar una condición de pago para la orden de compra.",
      );
      return;
    }

    if (esCombustible) {
      if (!fechaOrden) {
        showMsg(
          toast,
          "warn",
          "Advertencia",
          "Debe ingresar la fecha de la orden para compras de combustible.",
        );
        return;
      }
      if (impuestoEspecifico === null || impuestoEspecifico === undefined) {
        showMsg(
          toast,
          "warn",
          "Advertencia",
          "Debe ingresar el impuesto específico para compras de combustible.",
        );
        return;
      }
    }

    // Build Final Order Object
    let objOrdenCompra: OrdenCompra = {
      id_sub_tipo_documento: selectedSolicitudeHeaders.current[0].subdoc_id,
      id_usuario_solicitante: initData.id,
      id_mes_gasto: selectedSolicitudeHeaders.current[0].meses_id,
      id_estado_operacional: selectedSolicitudeHeaders.current[0].estope_id,
      id_tipo_moneda: selectedSolicitudeHeaders.current[0].tipmon_id,
      id_proveedor: selectedSolicitudeDetails.current[0].prov_id,
      url_orden_compra_pdf: "",
      url_archivos_asociados_pdf: "",
      observaciones: selectedSolicitudeHeaders.current[0].soc_observaciones,
      tipo_cambio_dia: selectedTasaCambio,
      id_estado_orden: 1,
      id_tipo_doc_tributario: selectedTipoDocTributarioId,
      condicion_pago: selectedCondicionPagoId,
      es_combustible: esCombustible,
      fecha_orden: esCombustible ? fechaOrden : null,
      impuesto_especifico: esCombustible ? impuestoEspecifico : null,
      dt_cre: new Date(),
      dt_mod: new Date(),
      detalles: selectedSolicitudeDetails.current,
    };

    setShowModalDetails(false);
    setShowModalConfirm(true);
    setJsonDataOrdenCompra(objOrdenCompra);
  };


  const rowExpansionTemplate = (data: any) => {
    return (
      <div className="oc-expansion">
        <div className="oc-expansion__header">
          <div className="oc-expansion__title">
            <i className="pi pi-list" />
            <span>
              Detalle de la solicitud <strong>#{data.soc_id}</strong>
            </span>
            <span className="oc-chip">{data.detalle.length} ítems</span>
          </div>
          <div className="oc-expansion__actions">
            <Button
              label="SOC PDF"
              icon="pi pi-file-pdf"
              className="oc-btn oc-btn--pdf"
              onClick={() => {
                fetchDatosAprobacionesConfirmaciones(data.soc_id).then(() => {
                  fetchDatosFirmaAprobacionesConfirmaciones(data.soc_id).then(
                    () => {
                      PdfCreator({
                        data: data,
                        initData: initData,
                        solicitudesApprovalStates:
                          solicitudesApprovalStates.current ?? [],
                        solicitudesSignApprovalHistory:
                          solicitudesSignApprovalHistory.current ?? [],
                      });
                    },
                  );
                });
              }}
            />
            {archivoBodyTemplate(data)}
          </div>
        </div>
        <p className="oc-expansion__hint">
          <i className="pi pi-info-circle" /> Seleccione los ítems a incluir en
          la orden. Deben compartir proveedor, moneda, tipo de documento y mes
          de gasto.
        </p>
        <DataTable
          className="oc-detail-table"
          value={data.detalle}
          selectionMode={rowClick ? null : "checkbox"}
          dataKey="socdet_id"
          selection={selectedRow}
          selectAll={
            data.detalle.length > 0 &&
            data.detalle.every((obj: any) => isDetailSelected(selectedRow, obj))
          }
          onSelectAllChange={(e: any) => onSelectedAllDetailsChange(e, data)}
          onSelectionChange={onSelectionDetailChange}
          totalRecords={totalRecords}
          size="small"
        >
          <Column
            selectionMode="multiple"
            headerStyle={{ width: "3rem" }}
            key={`socdet_id`}
            field="socdet_id"
          ></Column>
          <Column field="socdet_id" header="Id" sortable></Column>
          <Column
            field="socdet_cantidad"
            header="Cantidad"
            sortable
            bodyClassName="oc-num"
          ></Column>
          <Column field="sdetcc_nombre" header="Centro Costo" sortable></Column>
          <Column field="item_nombre" header="Item" sortable></Column>
          <Column field="prov_nombre" header="Proveedor" sortable></Column>
          <Column
            field="socdet_precio_unitario_ref"
            header="Precio ref. Unitario"
            body={precioUniBodyDetailTemplate}
            bodyClassName="oc-num"
            sortable
          ></Column>
          <Column
            field="socdet_precio_total_ref"
            header="Precio ref. Total"
            sortable
            bodyClassName="oc-num oc-num--strong"
            body={precioUniTotalBodyDetailTemplate}
          ></Column>
          <Column
            field="socdet_observaciones"
            header="Detalles"
            sortable
          ></Column>
          <Column field="socest_nombre" header="Estado" sortable></Column>
        </DataTable>
      </div>
    );
  };

  const formatCurrency = (value: any) => {
    return value.toLocaleString("de-DE", {
      minimumFractionDigits: 4,
    });
  };
  const precioUniBodyDetailTemplate = (rowData: any) => {
    return formatCurrency(rowData.socdet_precio_unitario_ref);
  };
  const precioUniTotalBodyDetailTemplate = (rowData: any) => {
    return formatCurrency(rowData.socdet_precio_total_ref);
  };
  //************************************************************************************************/
  const header = (
    <div className="oc-toolbar">
      {renderHeader()}
      <div className="oc-toolbar__actions">
        <Button
          type="button"
          icon="pi pi-file-excel"
          label="Excel"
          className="oc-btn oc-btn--excel"
          onClick={exportExcel}
          data-pr-tooltip="XLS"
        />
      </div>
    </div>
  );

  const selectedCount = selectedRow?.length ?? 0;

  return (
    <div className="oc-create">
      {showModalConfirm ? (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <ModalConfirm
            header="Confirmación"
            text="¿Estás seguro de guardar la orden de compra?"
            show={true}
            setShowModalConfirm={setShowModalConfirm}
            setDocId={0}
            setNeedFetchingDoc={setNeedFetchingSoc}
            data={jsonDataOrdenCompra}
            jsonDestination="nvaordencompra"
            data2=""
            setGoHome={setGoHome}
          />
        </div>
      ) : null}

      {/* Modal de detalles de la nueva orden */}
      <Dialog
        header={
          <div className="oc-dialog__title">
            <span className="oc-dialog__icon">
              <i className="pi pi-file-edit" />
            </span>
            <div>
              <h3>Detalles de la nueva orden de compra</h3>
              <p>Complete los datos requeridos para continuar</p>
            </div>
          </div>
        }
        visible={showModalDetails}
        style={{ width: "620px" }}
        breakpoints={{ "960px": "75vw", "641px": "95vw" }}
        modal
        dismissableMask
        className="oc-dialog"
        onHide={() => setShowModalDetails(false)}
        footer={
          <div className="oc-dialog__footer">
            <Button
              label="Cancelar"
              icon="pi pi-times"
              className="oc-btn oc-btn--outline"
              onClick={() => setShowModalDetails(false)}
            />
            <Button
              label="Siguiente"
              icon="pi pi-arrow-right"
              iconPos="right"
              className="oc-btn oc-btn--primary"
              onClick={handleConfirmDetails}
            />
          </div>
        }
      >
        <div className="oc-form">
          <section className="oc-form__section">
            <div className="oc-field">
              <label className="oc-label">
                Tipo documento tributario <span className="oc-req">*</span>
              </label>
              <DropdownFilter
                id="os_tipo_doc_tributario_0"
                labelHead=""
                initialData={tiposDocumentosTributarios}
                data={selectedTipoDocTributario}
                dataId={selectedTipoDocTributarioId}
                handleUpdateItems={handleUpdateTipoDocTribFromChild}
                idRow={0}
                virtualScrollerOptions={{ itemSize: 100 }}
              />
            </div>

            <div className="oc-form__grid">
              <div className="oc-field">
                <label className="oc-label" htmlFor="tasaCambio">
                  Tasa cambio <span className="oc-req">*</span>
                </label>
                <InputNumber
                  inputId="tasaCambio"
                  minFractionDigits={4}
                  maxFractionDigits={4}
                  value={selectedTasaCambio}
                  onValueChange={(e) => setSelectedTasaCambio(e.value ?? null)}
                  className="oc-input"
                />
              </div>

              <div className="oc-field">
                <label className="oc-label">
                  Condición pago <span className="oc-req">*</span>
                </label>
                <DropdownFilter
                  id="os_condicion_pago_0"
                  labelHead=""
                  initialData={condicionesPago}
                  data={selectedCondicionPago}
                  dataId={selectedCondicionPagoId}
                  handleUpdateItems={handleUpdateCondicionPagoFromChild}
                  idRow={0}
                  virtualScrollerOptions={{ itemSize: 100 }}
                />
              </div>
            </div>
          </section>

          {/* Sección combustibles */}
          <section
            className={`oc-form__section oc-fuel ${
              esCombustible ? "oc-fuel--active" : ""
            }`}
          >
            <div className="oc-fuel__toggle">
              <Checkbox
                inputId="esCombustible"
                checked={esCombustible}
                onChange={(e) => setEsCombustible(e.checked ?? false)}
              />
              <label htmlFor="esCombustible">
                <i className="pi pi-car" />
                ¿Es una orden de compra de combustibles?
              </label>
            </div>

            {esCombustible && (
              <div className="oc-form__grid oc-fuel__fields">
                <div className="oc-field">
                  <label htmlFor="fechaOrden" className="oc-label">
                    Fecha orden <span className="oc-req">*</span>
                  </label>
                  <Calendar
                    id="fechaOrden"
                    value={fechaOrden}
                    onChange={(e) => setFechaOrden(e.value as Date)}
                    dateFormat="dd/mm/yy"
                    showIcon
                    placeholder="dd/mm/aaaa"
                    className="oc-input"
                  />
                </div>

                <div className="oc-field">
                  <label htmlFor="impuestoEspecifico" className="oc-label">
                    Impuesto específico <span className="oc-req">*</span>
                  </label>
                  <InputNumber
                    inputId="impuestoEspecifico"
                    value={impuestoEspecifico}
                    onValueChange={(e) =>
                      setImpuestoEspecifico(e.value ?? null)
                    }
                    minFractionDigits={0}
                    maxFractionDigits={0}
                    placeholder="Ej: 1500 o -500"
                    className="oc-input"
                  />
                </div>
              </div>
            )}
          </section>
        </div>
      </Dialog>

      {showModalFirma ? (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <ModalSignature setShowModalSignature={setShowModalFirma} />
        </div>
      ) : null}

      <Toast ref={toast} />

      <header className="om-hero oc-hero">
        <div className="om-hero-main">
          <div className="om-hero-icon" aria-hidden="true">
            <i className="pi pi-cart-plus" />
          </div>
          <div className="om-hero-text">
            <span className="om-eyebrow">Compras · Órdenes de compra</span>
            <h2 className="om-title">Creación de órdenes de compra</h2>
            <p className="om-hero-desc">
              En este módulo podrá crear una nueva orden de compra a partir de
              solicitudes en estado confirmadas, cumpliendo con los criterios
              establecidos.
            </p>
          </div>
        </div>

        <aside className="eol-leyenda oc-criterios" aria-label="Criterios">
          <div className="eol-titulo">
            <i className="pi pi-info-circle" aria-hidden="true" /> Criterios
            para agrupar ítems en una orden
          </div>
          <ul className="eol-lista">
            <li>
              <i className="pi pi-check" aria-hidden="true" />
              <span className="eol-texto">Mismo proveedor</span>
            </li>
            <li>
              <i className="pi pi-check" aria-hidden="true" />
              <span className="eol-texto">Mismo tipo de moneda</span>
            </li>
            <li>
              <i className="pi pi-check" aria-hidden="true" />
              <span className="eol-texto">Mismo tipo de documento</span>
            </li>
            <li>
              <i className="pi pi-check" aria-hidden="true" />
              <span className="eol-texto">Mismo mes de gasto</span>
            </li>
          </ul>
          <div className="oc-hero-stat">
            <span>{data.length}</span>
            <small>solicitudes confirmadas</small>
          </div>
        </aside>
      </header>

      <div className="oc-card">
        <DataTable
          className="oc-table"
          value={data}
          paginator
          rows={10}
          stripedRows
          dataKey="soc_id"
          filters={filters}
          filterDisplay="row"
          loading={isLoading}
          globalFilterFields={[
            "subdoc_nombre",
            "item_nombre",
            "soc_id",
            "nombres",
            "cc_nombre",
            "soc_dt_cre",
            "socest_nombre",
          ]}
          header={header}
          emptyMessage={
            <div className="oc-empty">
              <i className="pi pi-inbox" />
              <span>No se encontraron solicitudes...</span>
            </div>
          }
          expandedRows={expandedRows}
          onRowToggle={(e) =>
            setExpandedRows(e.data as DataTableExpandedRows[] | undefined)
          }
          onRowExpand={onRowExpand}
          onRowCollapse={onRowCollapse}
          rowExpansionTemplate={rowExpansionTemplate}
        >
          <Column expander={allowExpansion} style={{ width: "3.5rem" }} />
          <Column
            field="subdoc_nombre"
            header="Tipo Orden"
            filter
            filterPlaceholder="Buscar Tipo"
            filterMenuStyle={{ width: "12rem" }}
            style={{ minWidth: "12rem" }}
          />
          <Column
            field="soc_id"
            header="N° Solicitud"
            filter
            filterPlaceholder="Buscar N°"
            filterMenuStyle={{}}
            style={{ minWidth: "10rem" }}
            bodyClassName="oc-id"
          />
          <Column
            field="nombres"
            header="Solicitante"
            filterField="nombres"
            filterMenuStyle={{ width: "14rem" }}
            style={{ minWidth: "14rem" }}
            body={solicitanteBodyTemplate}
            filter
            filterPlaceholder="Buscar solicitante"
          />
          <Column
            field="cc_nombre"
            header="Centro Solicitante"
            filterField="cc_nombre"
            filter
            filterPlaceholder="Buscar por centro"
            filterMenuStyle={{ width: "14rem" }}
            style={{ minWidth: "14rem" }}
          />
          <Column
            field="soc_dt_cre"
            header="Fecha Creación"
            filter
            filterPlaceholder="Buscar fecha"
            filterMenuStyle={{ width: "14rem" }}
            style={{ minWidth: "11rem" }}
          />

          <Column
            field="soc_observaciones"
            header="Observaciones"
            style={{ minWidth: "14rem" }}
            bodyClassName="oc-muted"
          />
          <Column
            field="socest_nombre"
            header="Estado"
            showFilterMenu={false}
            filterMenuStyle={{ width: "14rem" }}
            style={{ minWidth: "12rem" }}
            body={estadoBodyTemplate}
            filter
            filterPlaceholder="Buscar por estado"
            filterElement={estadoRowFilterTemplate}
          />
        </DataTable>
      </div>

      <div className="oc-actionbar">
        <div className="oc-actionbar__info">
          {initData?.firma == null ? (
            <>
              <i className="pi pi-exclamation-triangle oc-warn" />
              <span>
                Necesita registrar su firma antes de generar órdenes de compra.
              </span>
            </>
          ) : (
            <>
              <span className="oc-badge">{selectedCount}</span>
              <span>
                {selectedCount === 1
                  ? "ítem seleccionado"
                  : "ítems seleccionados"}
              </span>
            </>
          )}
        </div>

        {initData?.firma == null ? (
          <Button
            className="oc-btn oc-btn--secondary oc-btn--lg"
            icon="pi pi-pencil"
            label="CREA TU FIRMA"
            onClick={() => setShowModalFirma(true)}
          />
        ) : null}

        {initData?.firma !== null ? (
          <Button
            className="oc-btn oc-btn--cta oc-btn--lg"
            icon="pi pi-check-circle"
            label="GENERAR"
            onClick={() => {
              saveOrdenCompra();
            }}
          />
        ) : null}
      </div>
    </div>
  );
}
